import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHandle: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17 6.66699C17 6.26699 17.4 6 18 6C18.6 6 19 6.26699 19 6.66699V17.333C19 17.733 18.6 18 18 18C17.4 18 17 17.733 17 17.333V6.66699ZM11 6.66699C11 6.26699 11.4 6 12 6C12.6 6 13 6.26699 13 6.66699V17.333C13 17.733 12.6 18 12 18C11.4 18 11 17.733 11 17.333V6.66699ZM5 6.66699C5 6.26699 5.4 6 6 6C6.6 6 7 6.26699 7 6.66699L7 17.333C7 17.733 6.6 18 6 18C5.4 18 5 17.733 5 17.333L5 6.66699Z',
    })
  )
}
